<template>
  <a-form-model
    ref="ruleForm"
    :model="form"
    :rules="rules"
    class="demo__FormModal demo__align-left demo__margin-top--8"
  >
    <a-form-model-item
      :ref="field.key"
      :prop="field.key"
      :label="field.label"
      v-for="field in stepFields"
      :key="field.key"
      class="demo__margin-top--16 demo__margin-bottom--0"
      v-bind:class="{
        'demo__FormModal--required': field.required,
      }"
    >
      <a-input v-model="form[field.key]" class="demo__input" />
    </a-form-model-item>
    <a-form-model-item class="demo__margin-top--24">
      <div class="demo__flex demo__flex-middle demo__flex-between">
        <div
          class="demo__font--16 demo__weight--600 demo__color--black demo__flex demo__flex-middle demo__pointer"
          @click="$root.$emit('changeRegStep', 1)"
        >
          <i class="fa-regular fa-chevron-left demo__margin-right--12"></i>
          <div>
            {{ $t("Back") }}
          </div>
        </div>

        <a-button
          class="demo__button demo__button--base"
          :disabled="nextStepDisabled"
          @click="changeStepTo3"
        >
          <span>
            {{ $t("To next") }}
          </span>
          <i class="fa-light fa-chevron-right demo__margin-left--12"></i>
        </a-button>
      </div>
      <div class="demo__font--14 demo__weight--600 demo__margin-top--16">
        <span class="demo__color--black">
          {{ $t("Have account?") }}
        </span>
        <AuthLockBlock
          class="demo__color--brandPrimary demo__pointer demo__inline"
        >
          {{ $t("Submit") }}
        </AuthLockBlock>
      </div>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    form: {
      required: true,
      type: Object,
    },
  },
  methods: {
    changeStepTo3() {
      this.$root.$emit("changeRegStep", 3);
      if (window.ym) {
        this.$root.$emit("reachGoal", {
          goalName: "signup",
          data: { step: 3 },
        });
        this.$debug("YA METRICS: событие signup with step 3", "ya_metric");
      }
    },
  },
  computed: {
    ...mapGetters(["userLinks"]),
    stepFields() {
      return [
        {
          key: "last_name",
          label: this.$t("Your last_name"),
          required: true,
        },
        {
          key: "first_name",
          label: this.$t("Your first_name"),
          required: true,
        },
        {
          key: "middle_name",
          label: this.$t("Your middle_name"),
        },
        {
          key: "company",
          label: this.$t("Your company"),
          required: true,
        },
        {
          key: "position_in_the_company",
          label: this.$t("Your position_in_the_company"),
          required: true,
        },
      ];
    },
    rules() {
      return {
        last_name: [
          {
            min: 2,
            message: this.$t("Min 2"),
            trigger: "change",
          },
          {
            required: true,
            message: this.$t("Field required"),
            trigger: "change",
          },
        ],
        first_name: [
          {
            min: 2,
            message: this.$t("Min 2"),
            trigger: "change",
          },
          {
            required: true,
            message: this.$t("Field required"),
            trigger: "change",
          },
        ],
        company: [
          {
            min: 2,
            message: this.$t("Min 2"),
            trigger: "change",
          },
          {
            required: true,
            message: this.$t("Field required"),
            trigger: "change",
          },
        ],
        position_in_the_company: [
          {
            min: 2,
            message: this.$t("Min 2"),
            trigger: "change",
          },
          {
            required: true,
            message: this.$t("Field required"),
            trigger: "change",
          },
        ],
      };
    },
    nextStepDisabled() {
      return (
        this.stepFields.filter((step) => {
          return (
            step.required &&
            (!this.form[step.key] || this.form[step.key].length < 2)
          );
        }).length > 0
      );
    },
  },
  created() {
    this.$accessModule("step2", this);
  },
};
</script>
